import React from 'react';
import {UngroupOutlined,FileOutlined,DatabaseOutlined,ApiOutlined,UserOutlined,DownloadOutlined, AreaChartOutlined } from '@ant-design/icons';
import { Menu,Divider,Layout } from 'antd';
import { Link} from "react-router-dom";
import { useSelector } from "react-redux";
import FileService  from './FileConstants';
import FileSaver from 'file-saver';

const { Sider} = Layout;

const SiderBar = (props) => {
    const id= props.props;
    const { user: currentUser } = useSelector((state) => state.auth);

  const handleDownload = async() => { 
    
    let sliceSize = 1024;
    let byteCharacters = window.atob(FileService.EXCEL_FILE_BASE64);
    let bytesLength = byteCharacters.length;
    let slicesCount = Math.ceil(bytesLength / sliceSize);
    let byteArrays = new Array(slicesCount);
    for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      let begin = sliceIndex * sliceSize;
      let end = Math.min(begin + sliceSize, bytesLength);
      let bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    FileSaver.saveAs(
      new Blob(byteArrays, { type: "application/vnd.ms-excel" }),
      "Api-test-cases.xlsx"
    );
  }
  return (
    <>
    <Sider width={200} collapsible 
    style={{
      overflow: 'auto',
      left: 0,
      top: 0,
      bottom: 0,
      backgroundColor:'transparent',
      height:'70vh'}}>
    <Menu style={{marginTop:'8%',minHeight:'30em',height:'100%',fontWeight:500}} 
      defaultSelectedKeys={[id]}>
    <Menu.Item icon={<UserOutlined/>} key='1'><Link to='/Profile'>My Profile</Link></Menu.Item>
    <Menu.Item icon={<FileOutlined/>} key='2'><Link to='/KycDetails'>Kyc Details</Link></Menu.Item>
    <Menu.Item icon={<ApiOutlined />} key='3'><Link to='/ApiParameters'>API Parameters</Link></Menu.Item>
      <Divider/>
    <Menu.Item icon={<DatabaseOutlined />}key='4'><Link to='/Collections'>API Collections</Link></Menu.Item>
    <Menu.Item icon={<UngroupOutlined />} key='5'><Link to='/MyCollection'>My Collection</Link></Menu.Item>
    <Menu.Item icon={<AreaChartOutlined />} key='6'><Link to=''>Reports</Link></Menu.Item>
      <Divider/>
    <Menu.Item icon={<DownloadOutlined />} /*onClick={()=>handleDownload()}*/ key='7'><Link to={FileService.API_TEST_CASE_FILE} download={"API Test Cases "+currentUser.MerchantNumber} target="_blank">Download Test Cases</Link> </Menu.Item>
   </Menu>
  </Sider>
  </>
  )
}

export default SiderBar